import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flag-jp",
  "use": "icon-flag-jp-usage",
  "viewBox": "0 0 1536 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1536 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-flag-jp\"><path d=\"M0 0h1536v1024H0z\" fill=\"#FFFFFF\" p-id=\"6592\" data-spm-anchor-id=\"a313x.search_index.0.i5.719e3a81PE3uJi\" class=\"selected\" /><path d=\"M768 512m-307.2 0a307.2 307.2 0 1 0 614.4 0 307.2 307.2 0 1 0-614.4 0Z\" fill=\"#BC002D\" p-id=\"6593\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag-jp.svg
// module id = AK5P
// module chunks = 24